import { email, helpers, maxLength, required } from '@vuelidate/validators'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useEmail(
  field: string,
  t: TInstance,
) {
  return ({
    [`${field}`]: {
      required: helpers.withMessage(
        () => t('formValidatorMessages.email.required'),
        required,
      ),
      maxLength: helpers.withMessage(
        () => t('formValidatorMessages.email.maxLength'),
        maxLength(255),
      ),
      email: helpers.withMessage(
        () => t('formValidatorMessages.email.invalid'),
        email,
      ),
    },
  })
}
